module.exports = __webpack_public_path__ + "static/media/TaliaBahar-OnlineResume.cd1499e3.pdf";